/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import validatehoc from "../Validator";
import FileManagerUI from "../../ui/FileManager";

class FileManager extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
			value: "",
			isUploading: false,
			progress: 0,
			existingFiles: null,
		};
	}

	uploadError = error => {
		this.props.fieldApi.setError(error);
	};

	uploadSuccess = url => {
		this.props.fieldApi.setValue(url);
		this.props.fieldApi.setTouched(true);
	};

	removeFile = event => {
		event.preventDefault();
		event.stopPropagation();
		this.props.fieldApi.setValue(null);
		this.props.fieldApi.setTouched(true);
	};

	render() {
		const { fieldState, placeholder } = this.props;
		const { value, error } = fieldState;
		return (
			<FileManagerUI
				value={value}
				error={error}
				placeholder={placeholder}
				uploadError={this.uploadError}
				uploadSuccess={this.uploadSuccess}
				removeFile={this.removeFile}
			/>
		);
	}
}

FileManager.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	fieldApi: PropTypes.object,
	fieldState: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <FileManager fieldState={fieldState} {...props} />),
	"string"
);

export default Wrapper;
